import React, { useState, useContext, useEffect, useRef } from 'react';
import { Grid } from 'antd';
import { formatTime } from '../../utils/formatTime';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RecordingContext from './RecordingContext';
import RecordingBarPatient from './RecordingBarPatient';
import RecordingBarActions from './RecordingBarActions';
import RecordingMessageError from './RecordingMessageError';
import './RecordingBar.css';

export default function RecordingBar({ elapsedTime, patient, isRecording, problemType }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ctx = useContext(RecordingContext);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isPaused = ctx && ctx.isPaused;

  const handlePatientClick = () => {
    if (patient && patient.getUUID) {
      navigate(`/patients/${patient.getUUID()}`);
    } else {
      ctx.expandModal();
    }
  };

  const handlePause = () => {
    if (ctx.pauseOnly) {
      ctx.pauseOnly();
    } else {
      ctx.pauseRecording();
    }
  };

  const handleReview = () => {
    if (isPaused && ctx.expandModal) {
      ctx.expandModal();
    }
  };

  const handleResume = () => {
    if (ctx && ctx.resumeRecording) {
      ctx.resumeRecording();
    }
  };


  return (
    <>
      {problemType && (
        <RecordingMessageError type={problemType} titleOnly={screens.xs} />
      )}
      {/* Success message when recording and no error */}
      {/* {showSuccess && (
        <RecordingMessageSuccess message={t('session_recorder.subtitle')} />
      )} */}
      <div
        className="recording-bar"
        data-testid="recording-bar"
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          padding: '0 24px',
          boxSizing: 'border-box',
        }}
      >
        <div className="recording-bar__left" style={{ display: 'flex', alignItems: 'center' }}>
          <span className={`recording-bar__mic-indicator${isPaused ? ' recording-bar__mic-indicator--paused' : ' mic-indicator--animated'}`} />
          <span
            className={`recording-bar__timer${isPaused ? ' paused' : ''}`}
            style={{ fontFamily: 'monospace', width: 60, display: 'inline-block', textAlign: 'center' }}
          >
            {formatTime(elapsedTime)}
          </span>
        </div>
        <div className="recording-bar__center" style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {/* TBD - future feature */}
        </div>
        <div className="recording-bar__right" style={{ display: 'flex', alignItems: 'center', marginLeft: 16, flexShrink: 0, minWidth: 120, gap: 16 }}>
          {!screens.xs && (
            <RecordingBarPatient patient={patient} t={t} handlePatientClick={handlePatientClick} />
          )}
          <RecordingBarActions
            isPaused={isPaused}
            isRecording={isRecording}
            handlePause={handlePause}
            handleResume={handleResume}
            handleReview={handleReview}
          />
        </div>
      </div>
    </>
  );
}
